// The canonical (www-stripped) domain visibility's same-domain guard compares
// by (CEN-216): two GSC properties conflict exactly when their canonical
// domains are equal. Mirrors rest-api's `toCanonicalPropertyDomain` — the
// picker must disable exactly the rows the activation gate would reject, no
// more: a subdomain prefix stays distinct from its apex domain property.
const SC_DOMAIN_PREFIX = 'sc-domain:';
const HOST_SHAPE = /^[a-z0-9.-]+$/;
const MAX_HOST_LENGTH = 253;

function normalizeHost(value: string): string {
  return value.trim().toLowerCase().replace(/\.$/, '');
}

function toPropertyHost(siteUrl: string): string | null {
  const property = siteUrl.trim().toLowerCase();

  let host: string;
  if (property.startsWith(SC_DOMAIN_PREFIX)) {
    host = normalizeHost(property.slice(SC_DOMAIN_PREFIX.length));
  } else {
    try {
      host = normalizeHost(new URL(property).hostname);
    } catch {
      return null;
    }
  }

  if (!host || host.length > MAX_HOST_LENGTH || !HOST_SHAPE.test(host)) {
    return null;
  }
  return host;
}

export function toGscCanonicalDomain(siteUrl: string): string | null {
  const host = toPropertyHost(siteUrl);
  if (host === null) {
    return null;
  }
  const stripped = host.replace(/^www\./, '');
  return stripped.includes('.') ? stripped : host;
}
